export function modal() {
  /**
   * モーダルを開く共通処理
   * @param {HTMLElement} modal 開く対象のモーダル要素
   * @param {Boolean} [noScrollLock] ポップアップを開くときにbodyにis-modal-activeを付けるかどうか（必要に応じて）
   */
  function openModal(modal) {
    // 他にモーダルが開いていたら閉じる場合はここで制御（必要があれば）
    modal.classList.add('is-active');
    document.body.classList.add('is-modal-active');
  }

  /**
   * モーダルを閉じる共通処理
   * @param {HTMLElement} modal 閉じる対象のモーダル要素
   */
  function closeModal(modal) {
    modal.classList.remove('is-active');
    document.body.classList.remove('is-modal-active');
  }

  /**
   * 現在アクティブなモーダルを全部閉じる（1つしか開かない想定なら1件だけでも可）
   */
  function closeActiveModal() {
    const activeModal = document.querySelector('.modal.is-active');
    if (activeModal) {
      closeModal(activeModal);
    }
  }

  /**
   * 履歴の state からモーダルを復元する
   * @param {Object} state popstate 時に渡される state オブジェクト（{ modal: string | null } を想定）
   */
  function restoreModalFromState(state) {
    // まず全部閉じる（シンプルに実装するため）
    closeActiveModal();
    // state.modal に文字列が入っていれば、該当のモーダルを開く
    if (state && state.modal) {
      const modalToOpen = document.querySelector(`[data-modal="${state.modal}"]`);
      if (modalToOpen) {
        openModal(modalToOpen);
      }
    }
  }

  /**
   * モーダルを開く際に pushState する
   * @param {HTMLElement} modal 開きたいモーダル
   * @param {string} url 書き換えたいURL
   */
  function pushStateOpenModal(modal, url) {
    const modalId = modal.getAttribute('data-modal');
    // pushState の第1引数に { modal: "xxx" } を入れて履歴に残す
    window.history.pushState({ modal: modalId }, '', url);
    openModal(modal);
  }

  /**
   * モーダルを閉じる際に pushState する
   * @param {HTMLElement} modal 閉じたいモーダル
   * @param {string} url 戻したいURL
   */
  function pushStateCloseModal(modal, url) {
    // pushState の第1引数に { modal: null } を渡して「モーダルが閉じている状態」を履歴に記録
    window.history.pushState({ modal: null }, '', url);
    closeModal(modal);
  }

  // ----------------------------------------
  // 1) クローズボタンの設定
  // ----------------------------------------
  const modals = document.querySelectorAll('.modal');
  modals.forEach((modal) => {
    const closeBtn = document.querySelector('.modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const href = closeBtn.getAttribute('href'); // 例: "/" など
        if (href) {
          // pushState で履歴に「モーダル閉じた」状態を追加
          pushStateCloseModal(modal, href);
        } else {
          // href がないなら普通に閉じるだけ
          closeModal(modal);
        }
      });
    }
  });

  // ----------------------------------------
  // 2) トリガー（data-modal-trigger）の設定
  // ----------------------------------------
  const triggers = document.querySelectorAll('[data-modal-trigger]');
  triggers.forEach((trigger) => {
    const modalId = trigger.getAttribute('data-modal-trigger');
    const targetModal = document.querySelector(`[data-modal="${modalId}"]`);
    if (targetModal) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const href = trigger.getAttribute('href'); // 例: "/?modal=someModalId"
        if (href) {
          // pushState で「モーダル開いた」状態を追加
          pushStateOpenModal(targetModal, href);
        } else {
          // href がないなら普通に開くだけ
          openModal(targetModal);
        }
      });
    }
  });

  // ----------------------------------------
  // 3) ページ読み込み時の処理
  //    - URLパラメータからモーダルを開く
  //    - その状態を replaceState で履歴にセット (初期表示状態がモーダル開閉のどちらかを記録)
  // ----------------------------------------
  const urlParams = new URLSearchParams(window.location.search);
  const paramModal = urlParams.get('modal'); // 例: "someModalId"
  if (paramModal) {
    // data-modal="someModalId" を持つモーダルがあれば開く
    const initialModal = document.querySelector(`[data-modal="${paramModal}"]`);
    if (initialModal) {
      openModal(initialModal);
      // 初期状態を履歴に「モーダルが開いている」状態として置き換え
      window.history.replaceState({ modal: paramModal }, '', window.location.href);
    } else {
      // パラメータあるけど該当モーダルがなければ「モーダルなし」状態を記録
      window.history.replaceState({ modal: null }, '', window.location.href);
    }
  } else {
    // パラメータがなければ「モーダルなし」状態を記録
    window.history.replaceState({ modal: null }, '', window.location.href);
  }

  // ----------------------------------------
  // 4) popstate イベントの監視
  //    - 戻るボタン / 進むボタン のどちらも popstate が発火する
  //    - state に入れておいた modal の値を参照してモーダルを再現
  // ----------------------------------------
  window.addEventListener('popstate', (event) => {
    const state = event.state || {};
    restoreModalFromState(state);
  });
}